<template>
	<dms-edit-layout v-bind="layoutProps">
		<dms-row>
				<dms-card row>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-input :value.sync="DateStamp" label-key="DATE_STAMP" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-input :value.sync="ZaznamId" label-key="ID" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-input :value.sync="CdbMethod" label-key="CDB_METHOD" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
					<dms-input :value.sync="DocType" label-key="DOC_TYPE" />
					</dms-col>
					<dms-col :md="24" :sm="24" :xs="24">
					<dms-input :value.sync="XmlDoc" :rows="20" type="textarea" label-key="XMLDOC" />
					</dms-col>
				</dms-card>
		</dms-row>
	</dms-edit-layout>
</template>

<script>
import { editFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store);
</script>
